import { Group, Progress, Text } from '@mantine/core';
import { Clock } from 'lucide-react';
import { useSessionTimerFromStartedAt } from '../../../../hooks/useSessionTimerFromStartedAt';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';

interface SessionTimerProps {
  session: DeviceConfigurationApi | undefined;
}

const formatTimeRemaining = (seconds: number): string => {
  if (seconds <= 0) return '0s';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  } else {
    return `${secs}s`;
  }
};

export const SessionTimer = ({ session }: SessionTimerProps) => {
  const { remainingSeconds, progressPercentage, isTimerActive } =
    useSessionTimerFromStartedAt(session);

  console.log('[SessionTimer] Component render:', {
    hasSession: !!session,
    sessionStatus: session?.status,
    sessionId: session?.id,
    isTimerActive,
    remainingSeconds,
    progressPercentage,
  });

  if (!isTimerActive) {
    console.log('[SessionTimer] ❌ Timer not active, returning null');
    return null;
  }

  console.log('[SessionTimer] ✅ Rendering timer');

  return (
    <Group gap='sm' align='center' wrap='nowrap'>
      <Clock size={16} style={{ color: 'var(--mantine-color-dimmed)' }} />
      <Text size='sm' c='dimmed'>
        Tempo rimanente:
      </Text>
      <Text size='sm' fw={600}>
        {formatTimeRemaining(remainingSeconds)}
      </Text>
      <div style={{ flex: 1, minWidth: 100 }}>
        <Progress
          value={progressPercentage}
          size='sm'
          color='blue'
          radius='sm'
          aria-label='Progresso sessione'
        />
      </div>
    </Group>
  );
};
